(function ($) {
    $.fn.lettering = function(name) {
        var t = this.text(),
            tl = t.length,
            r = '';
        for(var i = 0; i < tl; i++) {
            r += '<span class="' + name + '-' + i + '">' + t[i] + '</span>';
        }
        this.html(r);
    };

    function setScrollPercentforButton() {
        var scrollAmount = $(window).scrollTop();
        var documentHeight = $(document).height();
        var windowHeight = $(window).height();
        var scrollPercent = (scrollAmount / (documentHeight - windowHeight)) * 100;

        $(".section-download_button .circle-inner .wave").css("transform", "translateY("+scrollPercent+"%)");
        if(scrollPercent === 100) {
            $(".section-download_button .circle-inner .wave").addClass("-end");
        } else {
            $(".section-download_button .circle-inner .wave").removeClass("-end");
        }
    }

    if ($(".section-download_button").length > 0) {
        $('.section-download_button .circle .text').lettering('char');

        setScrollPercentforButton();

        $(document).on('scroll', function(){
            setScrollPercentforButton();
        });
    }
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/custom/progress-btn.es6